import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectionListChange } from '@angular/material/list';
import { MatSelectChange } from '@angular/material/select';
import { TranslateService } from '@ngx-translate/core';
import { filter_options } from 'src/app/constants/filterTypes';
import { Columns, DataStore } from 'src/app/models/responses/dataStoreResponse';
import { Node } from 'src/app/models/responses/nodeResponse';
import { CoreService } from 'src/app/services/core/core.service';
import { DataStoreService } from 'src/app/services/dataStore/data-store.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { SweetAlertService } from 'src/app/services/sweet-alert/sweet-alert.service';

interface collectionData { collectionName: string, joinType: string, joinColumn: { source: string, destination: string }, selected: boolean }
interface columnData {
  [collectionName: string]: (Columns & { selected: boolean, asName: string })[]
}

interface conditionFormType {
  formId: number, formGroup: FormGroup, type: string
}

@Component({
  selector: 'app-design-data-form',
  templateUrl: './design-data-form.component.html',
  styleUrls: ['./design-data-form.component.scss']
})
export class DesignDataFormComponent implements OnInit {
  dataStores: DataStore[] = []
  selectedCollections: string[] = []
  selectedColumns: string[] = []
  columnTypes: Columns[] = []
  // allColumns: (Columns & { selected: boolean, asName: string, collectionName: string })[] = []

  selectedDs: DataStore
  collections: collectionData[] = [];
  columns: columnData = {};
  columnCount: number = 0
  mainCollectionName: string = ''
  conditionForms: conditionFormType[] = []
  codeScreen: boolean = false
  DBViewForm: FormGroup = new FormGroup({
    viewName: new FormControl('', [Validators.required]),
    dataStoreId: new FormControl('', [Validators.required])

  })

  joinTypeSelect = [
    { text: 'Main', value: 'Main' },
    { text: 'Join', value: 'Join' },
    { text: 'Inner Join', value: 'Inner Join' },
    { text: 'Left Join', value: 'Left Join' },
    { text: 'Right Join', value: 'Right Join' }

  ]

  selectionListErrorText: string = ''

  rowData: any[] = []


  conditionOperators = filter_options.filter(x => x.type.length <= 0 || x.type.includes('System.Number') || x.type.includes('System.String'))

  editorOptions = { theme: 'vs-dark', language: 'sql' };
  code: string = `CREATE VIEW customer_orders AS
SELECT
    customers.id AS customer_id,
    customers.name AS customer_name,
    orders.id AS order_id,
    orders.total
FROM
    customers
JOIN
    orders ON customers.id = orders.customer_id;`;

  createdCode: string = ''

  customizeCode: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) private data: {
    dataStores: DataStore[],
    nodes: Node[]
  }, private dialogRef: MatDialogRef<DesignDataFormComponent>,
    private dataStoreService: DataStoreService,
    private coreService: CoreService,
    private translate: TranslateService,
    private sweetAlertService: SweetAlertService) {
    this.dataStores = data.dataStores
  }

  ngOnInit(): void {

  }



  saveDesignedData() {
    var con = this.conditionForms.length > 0 ? this.conditionForms[this.conditionForms.length - 1].formGroup.valid ? true : false : true
    if (!this.customizeCode) {
      this.generateSQL();
    }
    if (this.DBViewForm.valid && this.selectionListErrorText.length <= 0 && con) {
      this.dataStoreService.CreateDatabaseObjects(this.selectedDs.dataStoreId, this.code).subscribe(res => {
        if (res.result) {
          this.coreService.showSuccessMessage(res.message);
          this.dialogRef.close(true);
        } else {
          this.coreService.showErrorMessage(res.message);
        }
      })
    } else {
      this.coreService.showFormFillError()
    }
  }


  selectJoinType(item: collectionData, joinType: { text: string, value: string }) {

    item.joinType = joinType.value
    this.errorTextUpdate();
  }


  errorTextUpdate() {
    if (!this.collections.some(x => x.joinType == 'Main')) {
      this.selectionListErrorText = 'Please Select Main Table!'
    } else if (this.collections.filter(x => x.joinType == 'Main').length > 1) {
      this.selectionListErrorText = 'Your Main Table Multiple. Please Select One Main Table!'
    } else if (this.collections.some(x => x.joinType.includes('Join') && (x.joinColumn.destination.length <= 0 || x.joinColumn.source.length <= 0))) {
      this.selectionListErrorText = 'Please Add Join Columns.'
    } else {
      this.selectionListErrorText = ''
    }
  }

  getSampleData() {
    var dataStoreId = this.DBViewForm.controls['dataStoreId'].value
    var Command = this.code
    if (dataStoreId && Command) {
      this.dataStoreService.CreateDatabaseObjects(dataStoreId, Command, 1).subscribe(res => {
        if (res.result) {
          this.rowData = res.message;
          var cols = []
          for (const collection of this.selectedCollections) {
            cols = this.columns[collection];
          }
          this.columnTypes = cols
        
        }
      })
    }
  }


  resetCode() {
    this.code = this.generateSQL()
    this.customizeCode = false
  }

  codeSelectionWarn(codeScreen: boolean) {

    const isChangeCode = this.createdCode.trim() !== this.code.trim();

    if (!codeScreen) {
      if (isChangeCode) {
        this.sweetAlertService.open(
          this.translate.instant("DataStoreFormPage.CustomCodeConfirmTitle"),
          this.translate.instant("DataStoreFormPage.CustomCodeConfirmText"),
          'question',
          this.translate.instant("Common.Yes"),
          (res) => {
            if (res.isConfirmed) {
              this.customizeCode = true;
              this.createdCode = this.code; //onaylanmış son geçerli kod
            }
            this.codeScreen = codeScreen;
          },
          true
        );
      } else {
        this.codeScreen = codeScreen;
      }
    } else {
      this.codeScreen = codeScreen;

      // Kullanıcı daha önce kodu özelleştirmediyse, varsayılanı yükle
      if (!this.customizeCode) {
        this.code = this.generateSQL();
        this.createdCode = this.code; // önemli! referans olarak kullanıyoruz
        this.getSampleData();
      }
    }
  }



  changeCollection(event: MatSelectionListChange) {
   
    var collectionName = event.options[0].value
    if (event.options[0].selected) {
      this.getColumns(this.selectedDs.nodeId, this.selectedDs.universe, collectionName)
    } else {
      delete this.columns[collectionName]
    }
    this.changeColumnCount();

  }

  private getCollections(nodeId: string, universe: string) {
    this.dataStoreService.getCollections(nodeId, universe).subscribe(result => {
      this.collections = result.map(item => {
        return {
          collectionName: item,
          joinType: '',
          selected: false,
          joinColumn: { source: '', destination: '' }
        }
      });
    });
  }

  changeSelectionForList(item: collectionData, event, type: string) {

    item.selected = event
    if (type == 'collection') {
      if (!event) {
        item.joinType = ''
      }
      if (this.collections.filter(x => x.selected).length == 1) {
        this.mainCollectionName = item.collectionName
        this.collections.find(x => x.selected).joinType = 'Main'
      } else {
        this.collections.filter(x => x.selected && x.joinType !== 'Main').map(item => item.joinType == '' ? item.joinType = 'Join' : '')
      }
    } else {
      // if (event) {
      //   this.selectedColumns.push(item)
      // } else {
      //   this.selectedColumns = this.selectedColumns.filter(x => x.fieldName !== item.fieldName)
      // }
      // console.log('selectedColumns', this.selectedColumns)
    }

    this.errorTextUpdate();
  }

  changeDataStoreSelection() {
    var selectedDsId = this.DBViewForm.controls['dataStoreId'].value;
    this.selectedDs = this.dataStores.find(x => x.dataStoreId == selectedDsId);
    this.conditionForms = []
    this.columns = {}
    this.getCollections(this.selectedDs.nodeId, this.selectedDs.universe);
  }

  changeColumnCount() {
    this.columnCount = Object.keys(this.columns).reduce((acc, key) => {
      return acc + this.columns[key].length;
    }, 0);
  }


  private getColumns(nodeId: string, universe: string, collectionName: string) {

    this.dataStoreService.getColumnsByNodeId(nodeId, universe, collectionName).subscribe((result: Columns[]) => {
      if (result) {
        var newColumns: (Columns & { selected: boolean, asName: string })[] = result.map(col => {
          var newColEl = {
            ...col,
            visibleName: collectionName + '.' + col.fieldName,
            collectionName: collectionName,
            selected: false,
            asName: col.fieldName
          }
          this.asNameChange(newColEl)

          return newColEl;
        })


        this.columns[collectionName] = newColumns

        this.changeColumnCount()
      }



    });
  }


  joinColumnSelection(event: MatSelectChange, item: collectionData, type: string) {
    item.joinColumn[type] = event.value
    this.errorTextUpdate();
  }


  addConditionFormGroup() {
    var lastId = this.conditionForms.length > 0 ? this.conditionForms[this.conditionForms.length - 1].formId : 0
    if (lastId == 0 || this.conditionForms[this.conditionForms.length - 1].formGroup.valid) {
      var newFG = new FormGroup({
        column: new FormControl('', [Validators.required]),
        operator: new FormControl('', [Validators.required]),
        value: new FormControl('', [Validators.required])
      })

      this.conditionForms.push({ formId: lastId + 1, formGroup: newFG, type: 'text' })
    } else {
      Object.values(this.conditionForms[this.conditionForms.length - 1].formGroup.controls).forEach(control => {
        control.markAsTouched();
        control.updateValueAndValidity();
      });
    }
  }

  changeConditionColumn(item: conditionFormType) {
    var selectedcol = item.formGroup.controls['column'].value;
    var collectionName = selectedcol.split('.')[0]
    var columnName = selectedcol.split('.')[1]

    var colType = this.columns[collectionName].find(x => x.fieldName == columnName).fieldType
    item.type = colType == "System.Number" ? 'number' : 'text';
    this.conditionOperators = filter_options.filter(x => x.type.length <= 0 || x.type.includes(colType))
  }

  asNameChange(column: (Columns & { selected: boolean, asName: string })) {
    let isUnique = false;
    let baseAsName = column.asName; // Orijinal asName'i saklayalım
    let counter = 1;

    // Benzersiz bir isim bulana kadar döngüyü sürdür
    while (!isUnique) {
      isUnique = true; // Başlangıçta benzersiz olduğunu varsayalım

      // Tüm sütunları kontrol et
      var colObjectKeys = Object.keys(this.columns);
      for (const item of colObjectKeys) {
        // Aynı asName'e sahip sütunları bul (kendisi hariç)
        const duplicates = this.columns[item].filter(x =>
          x.asName === column.asName && x !== column);

        if (duplicates.length > 0) {
          // Eşleşme varsa, benzersiz değil
          isUnique = false;

          // Yeni bir asName oluştur
          column.asName = baseAsName + counter;
          counter++;
          break; // İç döngüden çık ve tekrar kontrol et
        }
      }
    }

    return column.asName; // Güncellenmiş asName'i döndür
  }

  generateSQL() {
    var dbType = this.data.nodes.find(x => x.nodeId == this.selectedDs.nodeId)?.dataNodeType?.toLowerCase();


    const viewName = this.DBViewForm.get('viewName')?.value;
    const mainTable = this.mainCollectionName;
    const selectedColumns = [];

    for (const collection of this.selectedCollections) {
      const cols = this.columns[collection];
      for (const col of cols) {
        if (col.selected) {
          var collectionName = this.sqlToDbSyntaxText(collection, dbType)
          var colFieldName = this.sqlToDbSyntaxText(col.fieldName, dbType)

          const colName = `${collectionName}.${colFieldName}`;
          var colAsname = this.sqlToDbSyntaxText(col.asName, dbType)

          const asPart = col.asName ? ` AS ${colAsname}` : '';
          selectedColumns.push(`${colName}${asPart}`);
        }
      }
    }

    const selectClause = selectedColumns.length
      ? selectedColumns.join(',\n  ')
      : '*';

    // JOIN kısmı
    const joins = [];
    for (const collection of this.selectedCollections) {
      if (collection !== mainTable) {
        const item = this.collections.find(c => c.collectionName === collection);

        var collectionNameText = this.sqlToDbSyntaxText(collection, dbType)
        const sourceText = this.sqlToDbSyntaxText(item.joinColumn.source.split('.')[0], dbType) + '.' + this.sqlToDbSyntaxText(item.joinColumn.source.split('.')[1], dbType)
        const destText = this.sqlToDbSyntaxText(item.joinColumn.destination.split('.')[0], dbType) + '.' + this.sqlToDbSyntaxText(item.joinColumn.destination.split('.')[1], dbType)


        if (item?.joinType && item?.joinColumn.source && item?.joinColumn.destination) {
          joins.push(
            `${item.joinType.toUpperCase()} ${collectionNameText} ON ${sourceText} = ${destText}`
          );
        }
      }
    }

    // WHERE kısmı
    const whereClauses = [];
    for (const condition of this.conditionForms) {
      const form = condition.formGroup;
      const column = form.get('column')?.value;
      const operator = form.get('operator')?.value;
      const value = form.get('value')?.value;

      if (column && operator) {
        const formattedValue = isNaN(value) ? `'${value}'` : value;
        const columnText = this.sqlToDbSyntaxText(column, dbType)

        whereClauses.push(`${columnText} ${operator} ${formattedValue}`);
      }
    }

    const whereClause = whereClauses.length
      ? `\nWHERE ${whereClauses.join(' AND ')}`
      : '';

    const joinClause = joins.length ? '\n' + joins.join('\n') : '';

    const mainTableText = this.sqlToDbSyntaxText(mainTable, dbType)
    const viewNameText = this.sqlToDbSyntaxText(viewName, dbType)


    const sql = `
  CREATE VIEW ${viewNameText} AS
  SELECT
    ${selectClause}
  FROM ${mainTableText}${joinClause}${whereClause}`;


    this.createdCode = sql.trim();
    return this.createdCode
  }


  sqlToDbSyntaxText(text: string, dbType: string) {
    let quoteStart = '"', quoteEnd = '"';
    switch (dbType.toLowerCase()) {
      case 'postgresql':
      case 'clickhouse':
      case 'oracle':
        quoteStart = '"';  // PostgreSQL ve Oracle için çift tırnak
        quoteEnd = '"'
        break;
      case 'mysql':
      case 'mariadb':

        quoteStart = '`';  // MySQL, MariaDB, ClickHouse için geri tırnak (backtick)
        quoteEnd = '`'
        break;
      case 'mssql':
        quoteStart = '[';  // MSSQL için köşeli parantez
        quoteEnd = ']'
        break;
      default:
        throw new Error(`Unsupported DB type: ${dbType}`);
    }

    // Dışarıdan gelen sorguda tablolara ve kolonlara uygun quote karakterini ekleyelim
    return `${quoteStart}${text}${quoteEnd}`
  }

  deleteCondition(cForm: conditionFormType) {
    this.conditionForms = this.conditionForms.filter(x => x.formId !== cForm.formId)

  }



}
